import { render, staticRenderFns } from "./addRecipientSummary.vue?vue&type=template&id=b9b7d396&scoped=true"
import script from "./addRecipientSummary.vue?vue&type=script&lang=js"
export * from "./addRecipientSummary.vue?vue&type=script&lang=js"
import style0 from "./addRecipientSummary.vue?vue&type=style&index=0&id=b9b7d396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b7d396",
  null
  
)

export default component.exports